module.exports = __webpack_public_path__ + "media/images/game/categories/co_zivot_dal-fdfeccf4f93741d7eb08d365a6f6234c.png";